import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class WorkBusinessStatisticApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'work-business-statistic';
    }

   /**
    * 合同统计-数量或者金额统计
    * @param statisticalType 
    * @param timePeriod 
    * @param year 
    * @returns 
    */
    public getContractQuantityAmountStatistic(statisticalType,timePeriod,year) {
        return this.send({statisticalType,timePeriod,year}, "getContractQuantityAmountStatistic", Methods.GET);
    }

   /**
    * 合同统计-同比统计
    * @param statisticalType 
    * @param timePeriod 
    * @param year 
    * @returns 
    */
    public getContractYoYStatistic(statisticalType,timePeriod,year) {
        return this.send({statisticalType,timePeriod,year}, "getContractYoYStatistic", Methods.GET);
    }

   /**
    * 合同统计-环比统计
    * @param statisticalType 
    * @param timePeriod 
    * @param year 
    * @returns 
    */
    public getContractQOQStatistic(statisticalType,timePeriod,year) {
        return this.send({statisticalType,timePeriod,year}, "getContractQOQStatistic", Methods.GET);
    }

   /**
    * 合同统计-未完结合同
    */
    public getContractOutstandingStatistic() {
        return this.send({}, "getContractOutstandingStatistic", Methods.GET);
    }
    
   /**
    * 合同统计-质保金合同
    */
    public getContractWarrantyStatistic() {
        return this.send({}, "getContractWarrantyStatistic", Methods.GET);
    }
    
    

   /**
    * 发票统计
    * @param statisticalType 
    * @param timePeriod 
    * @param year 
    * @returns 
    */
    public getInvoiceStatistic(statisticalType,timePeriod,year) {
        return this.send({statisticalType,timePeriod,year}, "getInvoiceStatistic", Methods.GET);
    }
    

   /**
    * 环比增长率
    * @param timePeriod 
    * @param year 
    * @returns 
    */
    public getQOQRate(timePeriod,year) {
        return this.send({timePeriod,year}, "getQOQRate", Methods.GET);
    }

   /**
    * 查询已开票未回款
    * @returns 
    */
    public getUnpaid(year, timePeriod, timeNum) {
        return this.send({year, timePeriod, timeNum}, "getUnpaid", Methods.GET);
    }

    /**
    * 查询同比增长率
    * @param timePeriod 
    * @param year 
    * @returns 
    */
    public getYoYRate(timePeriod,year) {
        return this.send({timePeriod,year}, "getYoYRate", Methods.GET);
    }

    /**
    * 查询项目统计
    * @param year 
    * @returns 
    */
    public getProjectStatistic(year) {
      return this.send({year}, "getProjectStatistic", Methods.GET);
    }

    /**
    * 查询立项统计
    * @param year 
    * @returns 
    */
    public getProjectApprovalStatistic(year) {
      return this.send({year}, "getProjectApprovalStatistic", Methods.GET);
    }

    /**
    * 查询外业项目商务统计
    * @returns 
    */
    public getOutProjectStatistic(projectName,provinceName) {
      return this.send({projectName,provinceName}, "getOutProjectStatistic", Methods.GET);
    }

    /**
    * 查询采购物资类别统计
    * @param year 
    * @returns 
    */
    public getMaterialCategoryStatistic(year) {
      return this.send({year}, "getMaterialCategoryStatistic", Methods.GET);
    }

    /**
    * 查询采购统计
    * @param year 
    * @returns 
    */
    public getPurchaseStatistic(year) {
      return this.send({year}, "getPurchaseStatistic", Methods.GET);
    }

    /**
    * 查询采购物资统计
    * @param year 
    * @returns 
    */
    public getPurchaseMaterialStatistic(year) {
      return this.send({year}, "getPurchaseMaterialStatistic", Methods.GET);
    }

    /**
    * 查询采购类别统计
    * @param category 2-项目 3-办公 
    * @param year 
    * @returns 
    */
    public getPurchaseCategoryStatistic(category,year) {
      return this.send({category,year}, "getPurchaseCategoryStatistic", Methods.GET);
  }


  /**
    * 查询合同统计 - 合同总计
    * @param year 
    * @returns 
    */
  public getContractTotalStatistic(year) {
    return this.send({year}, "getContractTotalStatistic", Methods.GET);
  }
}